export default __webpack_public_path__ + "static/spray-edge-2-0e126f19fb7f9f3ce3b7b9901969eb44.webp";